type AuthEventType = 
  | 'sign_in_attempt'
  | 'sign_in_success' 
  | 'sign_in_error'
  | 'sign_up_attempt'
  | 'sign_up_success'
  | 'sign_up_error'
  | 'google_sign_in_attempt'
  | 'google_sign_in_error'
  | 'sign_out_attempt'
  | 'sign_out_success'
  | 'sign_out_error'
  | 'profile_updated'
  | 'user_loaded'
  | 'role_check'
  | 'admin_access_attempt'
  | 'admin_access_denied'
  | 'auth_state_change'
  | 'profile_load_attempt'
  | 'profile_load_success'
  | 'profile_load_error'
  | 'profile_load_failed'
  | 'profile_manual_creation_success'
  | 'profile_manual_creation_failed'
  | 'auth_confirm_error'
  | 'oauth_token_processing'
  | 'oauth_session_error'
  | 'oauth_session_success'
  | 'email_confirmation_processing'
  | 'email_confirmation_error'
  | 'email_confirmation_success'
  | 'auth_confirm_no_tokens'
  | 'auth_confirm_exception'
  | 'profile_fetch_start'
  | 'profile_created'
  | 'profile_creation_failed'
  | 'profile_fetch_error'
  | 'profile_fetch_success'
  | 'token_extraction_attempt'
  | 'token_validation_success'
  | 'token_validation_failed'
  | 'password_reset_token_received'
  | 'password_reset_session_established'
  | 'auth_confirm_redirect_attempt'
  | 'auth_confirm_session_check'
  | 'token_processing_timeout'
  | 'recovery_flow_started'
  | 'recovery_flow_completed'
  | 'session_persistence_check'
  | 'password_reset_request'
  | 'password_reset_error'
  | 'password_reset_success'
  | 'pkce_code_exchange_attempt'
  | 'pkce_code_exchange_failed'
  | 'pkce_code_exchange_success';

interface AuthEventData {
  userId?: string;
  email?: string;
  roles?: string[];
  error?: string;
  timestamp?: string;
  userAgent?: string;
  ip?: string;
  correlationId?: string;
  tokenPresent?: boolean;
  tokenType?: string;
  hasAccessToken?: boolean;
  hasRefreshToken?: boolean;
  actionType?: string;
  sessionValid?: boolean;
  redirectUrl?: string;
  [key: string]: any;
}

// Generate correlation ID for tracking user journeys
export function generateCorrelationId(): string {
  return `auth_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}

export function logAuthEvent(event: AuthEventType, data: AuthEventData = {}) {
  const logData = {
    event,
    timestamp: new Date().toISOString(),
    userAgent: navigator.userAgent,
    url: window.location.href,
    ...data
  };

  // Log to console in development
  if (process.env.NODE_ENV === 'development') {
    console.log(`[AUTH] ${event}:`, logData);
  }

  // TODO: In production, send to your analytics service
  // Examples: Mixpanel, PostHog, custom analytics endpoint
  // analytics.track(event, logData);
  
  // Store in localStorage for debugging (limit to last 100 events)
  try {
    const logs = JSON.parse(localStorage.getItem('auth_logs') || '[]');
    logs.unshift(logData);
    localStorage.setItem('auth_logs', JSON.stringify(logs.slice(0, 100)));
  } catch (error) {
    console.warn('Failed to store auth log:', error);
  }
}

export function getAuthLogs(): AuthEventData[] {
  try {
    return JSON.parse(localStorage.getItem('auth_logs') || '[]');
  } catch (error) {
    console.warn('Failed to retrieve auth logs:', error);
    return [];
  }
}

export function clearAuthLogs() {
  try {
    localStorage.removeItem('auth_logs');
  } catch (error) {
    console.warn('Failed to clear auth logs:', error);
  }
}
